import { createColDefs } from '@fortem-monorepo/react-ag'

export const pricingRequestsColDefs = createColDefs([
  {
    field: 'id',
    hide: true,
    width: 75,
  },
  {
    field: 'batchid',
    width: 100,
  },
  {
    field: 'structurename',
    width: 150,
  },
  {
    field: 'value_date',
    headerName: 'Value Date',
    width: 125,
  },
  {
    field: 'comment',
    headerName: 'Type',
    width: 125,
  },
  {
    field: 'uploadtimestamp',
    headerName: 'Upload Tsp UTC',
    width: 150,
  },
  {
    field: 'executed',
    width: 100,
  },
  {
    field: 'completed',
    width: 100,
  },
  {
    field: 'crashed',
    width: 100,
  },
  {
    field: 'executiontimestamp',
    headerName: 'Exec Tsp',
    width: 150,
  },
  {
    field: 'completiontimestamp',
    headerName: 'Comp Tsp',
    width: 150,
  },
  {
    field: 'crashtimestamp',
    headerName: 'Crash Tsp',
    width: 150,
  },
])

export const pricingInputsColDefs = createColDefs([
  {
    field: 'id',
    hide: true,
    width: 125,
  },
  {
    field: 'blockid',
    width: 125,
  },
  {
    field: 'comment',
    width: 100,
  },
  {
    field: 'instrumentticker',
    width: 100,
  },
  {
    headerName: 'Bumps',
    groupId: 'Bumps',
    children: [
      {
        field: 'spot_bump',
        headerName: 'Spot',
        width: 100,
      },
      {
        field: 'vol_bump',
        headerName: 'Vol',
        width: 100,
        columnGroupShow: 'open',
      },
      {
        field: 'div_bump',
        headerName: 'Div',
        width: 100,
        columnGroupShow: 'open',
      },
      {
        field: 'rates_bump',
        headerName: 'Rates',
        width: 100,
        columnGroupShow: 'open',
      },
      {
        field: 'time_bump',
        headerName: 'Time',
        width: 100,
        columnGroupShow: 'open',
      },
      {
        field: 'correlation_bump',
        headerName: 'Correl',
        width: 100,
        columnGroupShow: 'open',
      },
    ],
  },
  {
    headerName: 'Bumps Type',
    groupId: 'BumpsType',
    children: [
      {
        field: 'spot_bump_type',
        headerName: 'Spot',
        width: 100,
      },
      {
        field: 'vol_bump_type',
        headerName: 'Vol',
        width: 100,
        columnGroupShow: 'open',
      },
      {
        field: 'div_bump_type',
        headerName: 'Div',
        width: 100,
        columnGroupShow: 'open',
      },
      {
        field: 'rates_bump_type',
        headerName: 'Rates',
        width: 100,
        columnGroupShow: 'open',
      },
      {
        field: 'time_bump_type',
        headerName: 'Time',
        width: 100,
        columnGroupShow: 'open',
      },
      {
        field: 'correlation_bump_type',
        headerName: 'Correl',
        width: 100,
        columnGroupShow: 'open',
      },
    ],
  },
  {
    headerName: 'Add Options',
    children: [
      {
        field: 'ccy',
        width: 100,
      },
      {
        field: 'overhedgepercentagetenor',
        width: 100,
        columnGroupShow: 'open',
      },
      {
        field: 'fixedoverhedgewidth',
        width: 100,
        columnGroupShow: 'open',
      },
      {
        field: 'isbase',
        width: 100,
        columnGroupShow: 'open',
      },
      {
        field: 'usestochasticxccy',
        width: 100,
        columnGroupShow: 'open',
      },
    ],
  },
  {
    field: 'pv',
    width: 100,
  },
  {
    field: 'pv_bumped',
    headerName: 'PV Bump',
    width: 100,
  },
  {
    field: 'spot',
    width: 100,
  },
  {
    field: 'spot_bumped',
    headerName: 'Spot Bump',
    width: 100,
  },
  {
    field: 'coupon_gry',
    headerName: 'GRY',
    width: 100,
  },
  {
    field: 'yearcalled',
    headerName: 'Year Called',
    width: 100,
    wrapHeaderText: true,
  },
  {
    field: 'coupon_payoff',
    headerName: 'Coupon Payoff',
    width: 100,
    wrapHeaderText: true,
  },
  {
    field: 'funding_leg_payoff',
    headerName: 'Funding Payoff',
    width: 100,
    wrapHeaderText: true,
  },
  {
    field: 'total_payoff',
    headerName: 'Total Payoff',
    width: 100,
    wrapHeaderText: true,
  },
  {
    headerName: 'Barrier #1',
    children: [
      { field: 'b1_obs_dt', headerName: 'Obv Date', width: 100 },
      { field: 'barrier_1_pv', headerName: 'PV', width: 100 },
      { field: 'barrier_1_proba', headerName: 'Proba', width: 100 },
    ],
  },
  {
    headerName: 'Barrier #2',
    children: [
      { field: 'b2_obs_dt', headerName: 'Obv Date', width: 100 },
      { field: 'barrier_2_pv', headerName: 'PV', width: 100 },
      { field: 'barrier_2_proba', headerName: 'Proba', width: 100 },
    ],
  },
  {
    headerName: 'Barrier #3',
    children: [
      { field: 'b3_obs_dt', headerName: 'Obv Date', width: 100 },
      { field: 'barrier_3_pv', headerName: 'PV', width: 100 },
      { field: 'barrier_3_proba', headerName: 'Proba', width: 100 },
    ],
  },
  {
    headerName: 'Barrier #4',
    children: [
      { field: 'b4_obs_dt', headerName: 'Obv Date', width: 100 },
      { field: 'barrier_4_pv', headerName: 'PV', width: 100 },
      { field: 'barrier_4_proba', headerName: 'Proba', width: 100 },
    ],
  },
  {
    headerName: 'Barrier #5',
    children: [
      { field: 'b5_obs_dt', headerName: 'Obv Date', width: 100 },
      { field: 'barrier_5_pv', headerName: 'PV', width: 100 },
      { field: 'barrier_5_proba', headerName: 'Proba', width: 100 },
    ],
  },
  {
    headerName: 'Barrier #6',
    children: [
      { field: 'b6_obs_dt', headerName: 'Obv Date', width: 100 },
      { field: 'barrier_6_pv', headerName: 'PV', width: 100 },
      { field: 'barrier_6_proba', headerName: 'Proba', width: 100 },
    ],
  },
  {
    headerName: 'Barrier #7',
    children: [
      { field: 'b7_obs_dt', headerName: 'Obv Date', width: 100 },
      { field: 'barrier_7_pv', headerName: 'PV', width: 100 },
      { field: 'barrier_7_proba', headerName: 'Proba', width: 100 },
    ],
  },
  {
    headerName: 'Barrier #8',
    children: [
      { field: 'b8_obs_dt', headerName: 'Obv Date', width: 100 },
      { field: 'barrier_8_pv', headerName: 'PV', width: 100 },
      { field: 'barrier_8_proba', headerName: 'Proba', width: 100 },
    ],
  },
  {
    headerName: 'Barrier #9',
    children: [
      { field: 'b9_obs_dt', headerName: 'Obv Date', width: 100 },
      { field: 'barrier_9_pv', headerName: 'PV', width: 100 },
      { field: 'barrier_9_proba', headerName: 'Proba', width: 100 },
    ],
  },
  {
    headerName: 'Barrier #10',
    children: [
      { field: 'b10_obs_dt', headerName: 'Obv Date', width: 100 },
      { field: 'barrier_10_pv', headerName: 'PV', width: 100 },
      { field: 'barrier_10_proba', headerName: 'Proba', width: 100 },
    ],
  },
  {
    field: 'barrier_isdownandin',
    headerName: '#Barrier Kip',
    width: 150,
  },
])
